var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projects"},[(_vm.projects.length > 0)?_vm._l((_vm.projects),function(project){return _c('ProjectCard',_vm._g({key:project.id,attrs:{"project":project}},_vm.$listeners))}):[_vm._t("empty")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }